import { tenantApi } from '@/modules/tenant/services/tenantApi';
import type { operations } from '@marine/contracts/generated/api';
import type {
  CreateSubcontractorRequest,
  Subcontractor,
  UpdateSubcontractorRequest,
} from '../types/service.types';

/** D18-02 — query params of `GET /api/subcontractors` (from the generated contract). */
export type SubcontractorListParams = NonNullable<
  operations['listSubcontractors']['parameters']['query']
>;

/** D18-24 — no delete: a subcontractor is deactivated, never removed. */
export const subcontractorApi = {
  list: (params?: SubcontractorListParams) =>
    tenantApi.getPaginated<Subcontractor>('/subcontractors', { params }),

  get: (id: string) => tenantApi.getOne<Subcontractor>(`/subcontractors/${id}`),

  create: (data: CreateSubcontractorRequest) =>
    tenantApi.postOne<Subcontractor>('/subcontractors', data),

  update: (id: string, data: UpdateSubcontractorRequest) =>
    tenantApi.patchOne<Subcontractor>(`/subcontractors/${id}`, data),

  deactivate: (id: string) => tenantApi.postOne<Subcontractor>(`/subcontractors/${id}/deactivate`),

  reactivate: (id: string) => tenantApi.postOne<Subcontractor>(`/subcontractors/${id}/reactivate`),
};
